import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';

const DEPARTMENTS = [
  '项目管理部',
  '客户服务部',
  '工程维修部',
  '秩序维护部',
  '消防监控部',
  '环境管理部',
  '财务部'
];

export default function ChecklistAdmin({ user, embedded }) {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name:'', location:'', auto_task_department:'工程维修部' });
  const [items, setItems] = useState(['']);
  const [loading, setLoading] = useState(false);

  const isManager = ['admin','manager','general_manager','steward_chief'].includes(user.role);

  const fetch = async () => {
    try { const r = await API.get('/checklist/templates'); setTemplates(r.data); }
    catch { alert('加载失败'); }
  };
  useEffect(() => { fetch(); }, []);

  const openAdd = () => {
    setEditing(null);
    setForm({ name:'', location:'', auto_task_department:'工程维修部' });
    setItems(['']);
    setShowModal(true);
  };

  const openEdit = async (tpl) => {
    try {
      const r = await API.get(`/checklist/templates/${tpl.id}`);
      setEditing(r.data);
      setForm({ name: r.data.name, location: r.data.location, auto_task_department: r.data.auto_task_department });
      setItems(r.data.items.map(i => i.item_name).concat(['']));
      setShowModal(true);
    } catch { alert('加载失败'); }
  };

  const handleSave = async () => {
    if (!form.name || !form.location) { alert('请填写模板名称和地点'); return; }
    const validItems = items.filter(i => i.trim());
    if (validItems.length === 0) { alert('请至少添加一个巡检项目'); return; }
    setLoading(true);
    try {
      const payload = { ...form, items: validItems };
      if (editing) await API.put(`/checklist/templates/${editing.id}`, payload);
      else await API.post('/checklist/templates', payload);
      alert(editing ? '修改成功' : '创建成功');
      setShowModal(false);
      fetch();
    } catch { alert('操作失败'); }
    finally { setLoading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('确定删除此模板？关联的巡检记录不受影响。')) return;
    try { await API.delete(`/checklist/templates/${id}`); fetch(); }
    catch { alert('删除失败'); }
  };

  const updateItem = (idx, val) => {
    const next = [...items];
    next[idx] = val;
    if (idx === items.length - 1 && val) next.push('');
    setItems(next);
  };
  const removeItem = (idx) => setItems(items.filter((_, i) => i !== idx));

  return (
    <div style={s.container}>
      {!embedded && (
        <div style={s.header}>
          <button style={s.backBtn} onClick={() => navigate(-1)}>← 返回</button>
          <h2 style={s.title}>巡检清单模板</h2>
          {isManager && <button style={s.addBtn} onClick={openAdd}>+ 新建</button>}
        </div>
      )}
      {embedded && (
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'10px 16px'}}>
          <span style={{fontSize:'15px', fontWeight:600, color:'#333'}}>巡检清单模板</span>
          {isManager && <button style={{...s.addBtn, background:'#fa8c16', color:'#fff', borderRadius:'16px', padding:'6px 16px', border:'none', fontSize:'14px', cursor:'pointer'}} onClick={openAdd}>+ 新建</button>}
        </div>
      )}

      <div style={s.list}>
        {templates.length === 0 && <div style={s.empty}>暂无模板，点右上角新建</div>}
        {templates.map(tpl => (
          <div key={tpl.id} style={s.card}>
            <div style={s.cardTop}>
              <span style={s.cardName}>📋 {tpl.name}</span>
              <span style={s.cardCount}>{tpl.item_count} 项</span>
            </div>
            <div style={s.cardInfo}>📍 {tpl.location} · 异常派给 {tpl.auto_task_department}</div>
            {isManager && (
              <div style={s.cardBtns}>
                <button style={s.editBtn} onClick={() => openEdit(tpl)}>编辑</button>
                <button style={{...s.editBtn, background:'#ff4d4f', color:'#fff'}} onClick={() => handleDelete(tpl.id)}>删除</button>
              </div>
            )}
          </div>
        ))}
      </div>

      {showModal && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <h3 style={s.modalTitle}>{editing ? '编辑模板' : '新建巡检模板'}</h3>
            <div style={s.label}>模板名称 *</div>
            <input style={s.input} placeholder="如：排水井巡检" value={form.name} onChange={e => setForm({...form, name:e.target.value})} />
            <div style={s.label}>巡检地点 *</div>
            <input style={s.input} placeholder="如：排水井" value={form.location} onChange={e => setForm({...form, location:e.target.value})} />
            <div style={s.label}>异常时派单部门 *</div>
            <select style={s.input} value={form.auto_task_department} onChange={e => setForm({...form, auto_task_department:e.target.value})}>
              {DEPARTMENTS.map(d => <option key={d} value={d}>{d}</option>)}
            </select>
            <div style={s.label}>巡检项目 *（每行一条）</div>
            {items.map((item, idx) => (
              <div key={idx} style={{display:'flex', gap:'6px', marginBottom:'6px'}}>
                <input style={{...s.input, flex:1, marginBottom:0}} placeholder={`项目 ${idx+1}`}
                  value={item} onChange={e => updateItem(idx, e.target.value)} />
                {items.length > 1 && item && (
                  <button style={s.delItemBtn} onClick={() => removeItem(idx)}>×</button>
                )}
              </div>
            ))}
            <div style={s.modalBtns}>
              <button style={s.cancelBtn} onClick={() => setShowModal(false)}>取消</button>
              <button style={s.confirmBtn} onClick={handleSave} disabled={loading}>
                {loading ? '保存中...' : '保存'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  container: { minHeight:'100vh', background:'#f5f7fa' },
  header: { background:'linear-gradient(90deg,#d46b08,#fa8c16)', padding:'14px 16px', display:'flex', alignItems:'center', gap:'12px', position:'sticky', top:0, zIndex:100 },
  backBtn: { background:'rgba(255,255,255,0.2)', border:'none', color:'#fff', borderRadius:'8px', padding:'6px 12px', fontSize:'14px', cursor:'pointer' },
  title: { color:'#fff', margin:0, fontSize:'17px', fontWeight:700, flex:1 },
  addBtn: { background:'#fff', color:'#d46b08', border:'none', borderRadius:'16px', padding:'6px 16px', fontSize:'14px', fontWeight:600, cursor:'pointer' },
  list: { padding:'12px' },
  empty: { textAlign:'center', color:'#999', padding:'40px' },
  card: { background:'#fff', borderRadius:'10px', padding:'14px', marginBottom:'10px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)' },
  cardTop: { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'6px' },
  cardName: { fontSize:'16px', fontWeight:600, color:'#333' },
  cardCount: { background:'#e6f4ff', color:'#1890ff', borderRadius:'10px', padding:'2px 10px', fontSize:'13px' },
  cardInfo: { fontSize:'13px', color:'#888', marginBottom:'10px' },
  cardBtns: { display:'flex', gap:'8px' },
  editBtn: { padding:'6px 16px', border:'1px solid #d9d9d9', borderRadius:'6px', background:'#fff', cursor:'pointer', fontSize:'13px' },
  overlay: { position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.5)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:'16px' },
  modal: { background:'#fff', borderRadius:'12px', padding:'20px', width:'100%', maxWidth:'480px', maxHeight:'85vh', overflowY:'auto' },
  modalTitle: { margin:'0 0 16px', fontSize:'17px', fontWeight:700 },
  label: { fontSize:'13px', color:'#888', marginBottom:'6px', marginTop:'12px' },
  input: { width:'100%', padding:'10px 12px', fontSize:'15px', border:'1px solid #d9d9d9', borderRadius:'8px', boxSizing:'border-box', marginBottom:'4px' },
  delItemBtn: { padding:'10px 14px', border:'1px solid #ff4d4f', borderRadius:'8px', background:'#fff', color:'#ff4d4f', cursor:'pointer', fontSize:'16px' },
  modalBtns: { display:'flex', gap:'10px', marginTop:'20px' },
  cancelBtn: { flex:1, padding:'11px', border:'1px solid #d9d9d9', borderRadius:'8px', background:'#fff', cursor:'pointer', fontSize:'15px' },
  confirmBtn: { flex:2, padding:'11px', border:'none', borderRadius:'8px', background:'#fa8c16', color:'#fff', cursor:'pointer', fontSize:'15px', fontWeight:600 },
};
